import { render, staticRenderFns } from "./declarePolicy.vue?vue&type=template&id=9592e8ac&"
import script from "./declarePolicy.vue?vue&type=script&lang=js&"
export * from "./declarePolicy.vue?vue&type=script&lang=js&"
import style0 from "./declarePolicy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./declarePolicy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports